import React from "react";
import Automotive from "../../assets/icons/automotive.svg";
import Consumer from "../../assets/icons/consumer.svg";
import Banking from "../../assets/icons/banking.svg";
import Energy from "../../assets/icons/energy.svg";
import Industry from "../../assets/icons/industry.svg";
import Public from "../../assets/icons/public.svg";
import Retail from "../../assets/icons/retail.svg";
import { Parallax } from "react-parallax";

const TeamType = () => {
  return (
    <>
      <section className="bg-Gray-50 md:py-24 py-12 team-type">
        <div className="container sm:container md:container mx-auto">
          <div className="md:w-8/12 w-11/12 mx-auto">
            <h3 className="text-Gray-900 text-2xl md:text-4xl text-center font-avenirHeavy">
              Join our dynamic and collaborative team
            </h3>
            <p className="py-5 font-opensans  text-sm text-Gray-600 md:text-lg leading-relaxed font-normal text-center">
              We have the pleasure to work with many varying companies across a
              couple of industries. We have an extensive business knowledge in
              many different industries, such as
            </p>
            <div className="flex flex-row items-center md:pt-10 pt-5">
              <div className="grid md:grid-cols-4 grid-cols-2 md:gap-4 gap-8 w-full">
                <div className="text-center">
                  <Parallax
                    renderLayer={(percentage) => (
                      <div>
                        <div
                          style={{
                            position: "absolute",
                            background: `linear-gradient(131deg, #4c72ff 13%, #6ba7ff ${
                              percentage * 0.5
                            })`,

                            left: "30%",
                            top: "10%",
                            zIndex: "1",
                            opacity: ".25",
                            borderRadius: "28px",
                            transform: "translate(-10%,-10%)",
                            width: percentage * 90,
                            height: percentage * 90,
                          }}
                        />
                      </div>
                    )}
                  >
                    <img
                      src={Automotive}
                      alt=""
                      title=""
                      className="mx-auto relative z-10"
                    />
                    <span className="text-xs md:text-sm font-semibold md:font-normal md:text-base text-Gray-900 my-10">
                      Automotive
                    </span>
                  </Parallax>
                </div>
                <div className="text-center">
                  <Parallax
                    renderLayer={(percentage) => (
                      <div>
                        <div
                          style={{
                            position: "absolute",
                            background: `linear-gradient(123deg, #a04cff -4%, #ff98ef ${
                              percentage * 0.5
                            })`,

                            right: "20%",
                            bottom: "10%",
                            zIndex: "1",
                            opacity: ".25",
                            borderRadius: "28px",
                            transform: "translate(-10%,-10%)",
                            width: percentage * 90,
                            height: percentage * 90,
                          }}
                        />
                      </div>
                    )}
                  >
                    <img src={Consumer} alt="" title="" className="mx-auto" />
                    <span className="text-xs md:text-sm font-semibold md:font-normal md:text-base text-Gray-900 my-10">
                      Consumer products
                    </span>
                  </Parallax>
                </div>
                <div className="text-center">
                  <Parallax
                    renderLayer={(percentage) => (
                      <div>
                        <div
                          style={{
                            position: "absolute",
                            background: `linear-gradient(131deg, #4c72ff 13%, #6ba7ff ${
                              percentage * 0.5
                            })`,

                            left: "30%",
                            bottom: "10%",
                            zIndex: "1",
                            opacity: ".25",
                            borderRadius: "28px",
                            transform: "translate(-10%,-10%)",
                            width: percentage * 90,
                            height: percentage * 90,
                          }}
                        />
                      </div>
                    )}
                  >
                    <img src={Energy} alt="" title="" className="mx-auto" />
                    <span className="text-xs md:text-sm font-semibold md:font-normal md:text-base text-Gray-900 my-10">
                      Energy
                    </span>
                  </Parallax>
                </div>
                <div className="text-center">
                  <Parallax
                    renderLayer={(percentage) => (
                      <div>
                        <div
                          style={{
                            position: "absolute",
                            background: `linear-gradient(123deg, #a04cff -4%, #ff98ef ${
                              percentage * 0.5
                            })`,

                            left: "30%",
                            top: "10%",
                            zIndex: "1",
                            opacity: ".25",
                            borderRadius: "28px",
                            transform: "translate(-10%,-10%)",
                            width: percentage * 90,
                            height: percentage * 90,
                          }}
                        />
                      </div>
                    )}
                  >
                    <img src={Industry} alt="" title="" className="mx-auto" />
                    <span className="text-xs md:text-sm font-semibold md:font-normal md:text-base text-Gray-900 my-10">
                      Industrial Manufacturing
                    </span>
                  </Parallax>
                </div>
              </div>
            </div>
            <div className="flex flex-row items-center pt-5 md:pt-10 mx-auto md:w-3/4 w-full">
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 w-full">
                <div className="text-center">
                  <Parallax
                    renderLayer={(percentage) => (
                      <div>
                        <div
                          style={{
                            position: "absolute",
                            background: `linear-gradient(131deg, #4c72ff 13%, #6ba7ff ${
                              percentage * 0.5
                            })`,

                            left: "30%",
                            bottom: "10%",
                            zIndex: "1",
                            opacity: ".25",
                            borderRadius: "28px",
                            transform: "translate(-10%,-10%)",
                            width: percentage * 90,
                            height: percentage * 90,
                          }}
                        />
                      </div>
                    )}
                  >
                    <img src={Retail} alt="" title="" className="mx-auto" />
                    <span className="text-xs md:text-sm font-semibold md:font-normal md:text-base text-Gray-900 my-10">
                      Retail
                    </span>
                  </Parallax>
                </div>
                <div className="text-center">
                  <Parallax
                    renderLayer={(percentage) => (
                      <div>
                        <div
                          style={{
                            position: "absolute",
                            background: `linear-gradient(123deg, #a04cff -4%, #ff98ef ${
                              percentage * 0.5
                            })`,

                            right: "20%",
                            bottom: "10%",
                            zIndex: "1",
                            opacity: ".25",
                            borderRadius: "28px",
                            transform: "translate(-10%,-10%)",
                            width: percentage * 90,
                            height: percentage * 90,
                          }}
                        />
                      </div>
                    )}
                  >
                    <img src={Public} alt="" title="" className="mx-auto" />
                    <span className="text-xs md:text-sm font-semibold md:font-normal md:text-base text-Gray-900 my-10">
                      Public sector
                    </span>
                  </Parallax>
                </div>
                <div className="text-center">
                  <Parallax
                    renderLayer={(percentage) => (
                      <div>
                        <div
                          style={{
                            position: "absolute",
                            background: `linear-gradient(131deg, #4c72ff 13%, #6ba7ff ${
                              percentage * 0.5
                            })`,

                            top: "10%",
                            right: "20%",
                            zIndex: "1",
                            opacity: ".25",
                            borderRadius: "28px",
                            transform: "translate(-10%,-10%)",
                            width: percentage * 90,
                            height: percentage * 90,
                          }}
                        />
                      </div>
                    )}
                  >
                    <img src={Banking} alt="" title="" className="mx-auto" />
                    <span className="text-xs md:text-sm font-semibold md:font-normal md:text-base text-Gray-900 my-10">
                      Banking
                    </span>
                  </Parallax>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TeamType;
